/**
 * @generated SignedSource<<629dcfa203365737845091beb381365c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIntegrationTurnpikeSize = "TWO_X_ONE" | "TWO_X_TWO";
export type WidgetNoteSize = "TWO_X_ONE" | "TWO_X_TWO";
export type FocusSingleWidgetQuery$variables = {
  after?: string | null;
  first?: number | null;
  nodeId: string;
};
export type FocusSingleWidgetQuery$data = {
  readonly node: {
    readonly __typename: "File";
    readonly " $fragmentSpreads": FragmentRefs<"FileFocusScreen_file">;
  } | {
    readonly __typename: "WidgetCalendar";
    readonly " $fragmentSpreads": FragmentRefs<"WidgetCalendar_widgetCalendar">;
  } | {
    readonly __typename: "WidgetEmployeeSchedule";
    readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeSchedule_widgetEmployeeSchedule">;
  } | {
    readonly __typename: "WidgetFile";
    readonly " $fragmentSpreads": FragmentRefs<"WidgetFileStatic_widgetFile">;
  } | {
    readonly __typename: "WidgetIntegrationIpool";
    readonly " $fragmentSpreads": FragmentRefs<"WidgetIpoolIntegration_widgetIntegrationIpool" | "useWidgetToPosSingleSize_widget">;
  } | {
    readonly __typename: "WidgetIntegrationPushAppy";
    readonly webDashboardLink: string;
  } | {
    readonly __typename: "WidgetIntegrationTurnpike";
    readonly turnpikeSize: WidgetIntegrationTurnpikeSize;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetIntegrationTurnpike_widgetIntegrationTurnpike">;
  } | {
    readonly __typename: "WidgetIssueOverview";
    readonly " $fragmentSpreads": FragmentRefs<"IssueFocusScreen_widgetIssueOverview">;
  } | {
    readonly __typename: "WidgetIssueSummary";
    readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueSummary_widgetIssueSummary">;
  } | {
    readonly __typename: "WidgetNote";
    readonly noteSize: WidgetNoteSize;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetNote_widgetNote" | "useWidgetToPosSingleSize_widget">;
  } | {
    readonly __typename: "WidgetRoutineOverview";
    readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutineOverview_widgetRoutineOverview" | "useWidgetToPosSingleSize_widget">;
  } | {
    readonly __typename: "WidgetRoutinePositivePercentage";
    readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutinePositivePercentage_widgetRoutinePositivePercentage" | "useWidgetToPosSingleSize_widget">;
  } | {
    readonly __typename: "WidgetTaskCollection";
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskCollection_widgetTaskCollection" | "useWidgetToPosSingleSize_widget">;
  } | {
    readonly __typename: "WidgetTaskSingle";
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTaskSingle_widgetTaskSingle" | "useWidgetToPosSingleSize_widget">;
  } | {
    readonly __typename: "WidgetTeamSchedule";
    readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleFocusScreen_widgetTeamSchedule" | "WidgetTeamSchedule_widget" | "useWidgetToPosSingleSize_widget">;
  } | {
    readonly __typename: "WidgetTodoOverview";
    readonly " $fragmentSpreads": FragmentRefs<"TodoFocusScreen_widgetTodoOverview" | "WidgetTodoOverview_widget" | "useWidgetToPosSingleSize_widget">;
  } | {
    readonly __typename: "WidgetWeather";
    readonly " $fragmentSpreads": FragmentRefs<"WidgetWeather_widget" | "useWidgetToPosSingleSize_widget">;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type FocusSingleWidgetQuery = {
  response: FocusSingleWidgetQuery$data;
  variables: FocusSingleWidgetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nodeId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "nodeId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "useWidgetToPosSingleSize_widget"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noteSize",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webDashboardLink",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "turnpikeSize",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "height",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "overviewSize",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v20 = [
  (v15/*: any*/),
  (v9/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Team",
  "kind": "LinkedField",
  "name": "ownerTeam",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordinal",
  "storageKey": null
},
v23 = [
  (v9/*: any*/),
  (v15/*: any*/)
],
v24 = [
  (v11/*: any*/),
  (v9/*: any*/)
],
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v26 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expireAt",
  "storageKey": null
},
v28 = {
  "kind": "InlineFragment",
  "selections": [
    (v18/*: any*/)
  ],
  "type": "WidgetOverview",
  "abstractKey": "__isWidgetOverview"
},
v29 = {
  "kind": "InlineFragment",
  "selections": [
    (v6/*: any*/)
  ],
  "type": "WidgetNote",
  "abstractKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskSingleSize",
  "storageKey": null
},
v31 = {
  "kind": "InlineFragment",
  "selections": [
    (v30/*: any*/)
  ],
  "type": "WidgetTaskSingle",
  "abstractKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v33 = {
  "kind": "InlineFragment",
  "selections": [
    (v32/*: any*/)
  ],
  "type": "WidgetWeather",
  "abstractKey": null
},
v34 = {
  "kind": "InlineFragment",
  "selections": [
    (v8/*: any*/)
  ],
  "type": "WidgetIntegrationTurnpike",
  "abstractKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "freq",
  "storageKey": null
},
v37 = [
  {
    "kind": "Literal",
    "name": "includeInlineRoutines",
    "value": true
  }
],
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startAt",
  "storageKey": null
},
v39 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTeamScheduleEventOccasion"
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "Routine",
  "kind": "LinkedField",
  "name": "routine",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v40/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "descriptionImages",
      "plural": true,
      "selections": [
        (v9/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "minHeight",
              "value": 120
            },
            {
              "kind": "Literal",
              "name": "minWidth",
              "value": 120
            }
          ],
          "concreteType": "ImageSize",
          "kind": "LinkedField",
          "name": "size",
          "plural": false,
          "selections": (v24/*: any*/),
          "storageKey": "size(minHeight:120,minWidth:120)"
        }
      ],
      "storageKey": null
    },
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOrg",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deadlineAt",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequenceNumber",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "calculateNoTasks",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "status",
  "storageKey": "status(calculateNoTasks:true)"
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "issueCount",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalTaskExecutionCount",
  "storageKey": null
},
v47 = {
  "kind": "InlineFragment",
  "selections": [
    (v41/*: any*/),
    (v42/*: any*/),
    (v43/*: any*/),
    (v44/*: any*/),
    (v27/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/)
  ],
  "type": "RoutineOccasion",
  "abstractKey": null
},
v48 = [
  (v9/*: any*/),
  (v10/*: any*/)
],
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "Routine",
  "kind": "LinkedField",
  "name": "routine",
  "plural": false,
  "selections": (v48/*: any*/),
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "TaskCheck",
  "kind": "LinkedField",
  "name": "task",
  "plural": false,
  "selections": [
    (v9/*: any*/)
  ],
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sectionId",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "checkValue",
  "storageKey": null
},
v53 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TaskExecutionCheck",
      "kind": "LinkedField",
      "name": "taskExecution",
      "plural": false,
      "selections": [
        (v41/*: any*/),
        (v9/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineOccasion",
          "kind": "LinkedField",
          "name": "routineOccasion",
          "plural": false,
          "selections": [
            (v42/*: any*/),
            (v43/*: any*/),
            (v9/*: any*/),
            (v38/*: any*/),
            (v45/*: any*/),
            (v44/*: any*/),
            (v49/*: any*/),
            (v4/*: any*/),
            (v46/*: any*/)
          ],
          "storageKey": null
        },
        (v50/*: any*/),
        (v51/*: any*/),
        (v52/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "TeamScheduleInlineRoutineOccasion",
  "abstractKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endAt",
  "storageKey": null
},
v55 = {
  "kind": "InlineFragment",
  "selections": [
    (v54/*: any*/),
    (v10/*: any*/),
    (v40/*: any*/)
  ],
  "type": "TeamScheduleOneOffEvent",
  "abstractKey": null
},
v56 = [
  (v9/*: any*/),
  (v35/*: any*/),
  (v36/*: any*/),
  {
    "alias": null,
    "args": (v37/*: any*/),
    "concreteType": null,
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      (v9/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      (v47/*: any*/),
      (v53/*: any*/),
      (v55/*: any*/)
    ],
    "storageKey": "events(includeInlineRoutines:true)"
  }
],
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamSchedule",
  "kind": "LinkedField",
  "name": "dailyTeamSchedule",
  "plural": false,
  "selections": (v56/*: any*/),
  "storageKey": null
},
v58 = [
  (v9/*: any*/),
  (v36/*: any*/),
  (v35/*: any*/),
  {
    "alias": null,
    "args": (v37/*: any*/),
    "concreteType": null,
    "kind": "LinkedField",
    "name": "events",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      (v9/*: any*/),
      (v38/*: any*/),
      (v39/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v44/*: any*/),
          (v46/*: any*/),
          (v41/*: any*/),
          (v42/*: any*/),
          (v43/*: any*/),
          (v27/*: any*/),
          (v45/*: any*/)
        ],
        "type": "RoutineOccasion",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TaskExecutionCheck",
            "kind": "LinkedField",
            "name": "taskExecution",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineOccasion",
                "kind": "LinkedField",
                "name": "routineOccasion",
                "plural": false,
                "selections": [
                  (v44/*: any*/),
                  (v4/*: any*/),
                  (v46/*: any*/),
                  (v9/*: any*/),
                  (v42/*: any*/),
                  (v43/*: any*/),
                  (v38/*: any*/),
                  (v45/*: any*/),
                  (v49/*: any*/)
                ],
                "storageKey": null
              },
              (v9/*: any*/),
              (v41/*: any*/),
              (v50/*: any*/),
              (v51/*: any*/),
              (v52/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "type": "TeamScheduleInlineRoutineOccasion",
        "abstractKey": null
      },
      (v55/*: any*/)
    ],
    "storageKey": "events(includeInlineRoutines:true)"
  }
],
v59 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isWidgetOverview"
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "condition",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v62 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 8
  }
],
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberValue",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v65 = {
  "kind": "InlineFragment",
  "selections": [
    (v28/*: any*/),
    (v34/*: any*/)
  ],
  "type": "Widget",
  "abstractKey": "__isWidget"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "FocusSingleWidgetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetFileStatic_widgetFile"
              },
              (v4/*: any*/)
            ],
            "type": "WidgetFile",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetIssueSummary_widgetIssueSummary"
              },
              (v4/*: any*/)
            ],
            "type": "WidgetIssueSummary",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetEmployeeSchedule_widgetEmployeeSchedule"
              },
              (v4/*: any*/)
            ],
            "type": "WidgetEmployeeSchedule",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "IssueFocusScreen_widgetIssueOverview"
              },
              (v4/*: any*/)
            ],
            "type": "WidgetIssueOverview",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TodoFocusScreen_widgetTodoOverview"
              },
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetTodoOverview_widget"
              },
              (v5/*: any*/)
            ],
            "type": "WidgetTodoOverview",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetTeamSchedule_widget"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TeamScheduleFocusScreen_widgetTeamSchedule"
              },
              (v5/*: any*/),
              (v4/*: any*/)
            ],
            "type": "WidgetTeamSchedule",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetWeather_widget"
              },
              (v5/*: any*/),
              (v4/*: any*/)
            ],
            "type": "WidgetWeather",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetNote_widgetNote"
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v4/*: any*/)
            ],
            "type": "WidgetNote",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetTaskSingle_widgetTaskSingle"
              },
              (v5/*: any*/),
              (v4/*: any*/)
            ],
            "type": "WidgetTaskSingle",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetTaskCollection_widgetTaskCollection"
              },
              (v5/*: any*/),
              (v4/*: any*/)
            ],
            "type": "WidgetTaskCollection",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetRoutineOverview_widgetRoutineOverview"
              },
              (v5/*: any*/),
              (v4/*: any*/)
            ],
            "type": "WidgetRoutineOverview",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetRoutinePositivePercentage_widgetRoutinePositivePercentage"
              },
              (v5/*: any*/),
              (v4/*: any*/)
            ],
            "type": "WidgetRoutinePositivePercentage",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetIpoolIntegration_widgetIntegrationIpool"
              },
              (v5/*: any*/),
              (v4/*: any*/)
            ],
            "type": "WidgetIntegrationIpool",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/),
              (v4/*: any*/)
            ],
            "type": "WidgetIntegrationPushAppy",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetIntegrationTurnpike_widgetIntegrationTurnpike"
              },
              (v8/*: any*/),
              (v4/*: any*/)
            ],
            "type": "WidgetIntegrationTurnpike",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetCalendar_widgetCalendar"
              },
              (v4/*: any*/)
            ],
            "type": "WidgetCalendar",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "FileFocusScreen_file"
              },
              (v4/*: any*/)
            ],
            "type": "File",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "FocusSingleWidgetQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v9/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slideshowDuration",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetFileEdge",
                "kind": "LinkedField",
                "name": "files",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "FilePage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "thumbhash",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ImageSize",
                            "kind": "LinkedField",
                            "name": "sizes",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "urlExpiresAt",
                                "storageKey": null
                              },
                              (v12/*: any*/),
                              (v13/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "File",
                    "kind": "LinkedField",
                    "name": "file",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v14/*: any*/),
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "WidgetFile",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unresolvedIssueCount",
                    "storageKey": null
                  },
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "WidgetIssueSummary",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "provider",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Employee",
                "kind": "LinkedField",
                "name": "employeesWithShifts",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EmployeeShift",
                    "kind": "LinkedField",
                    "name": "shifts",
                    "plural": true,
                    "selections": [
                      (v14/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formattedStartAtTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "formattedEndAtTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "durationSeconds",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startAtSecondsFromMidnight",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "EmployeeScheduleType",
                        "kind": "LinkedField",
                        "name": "scheduleType",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v17/*: any*/),
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "firstName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastName",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "WidgetEmployeeSchedule",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Issue",
                "kind": "LinkedField",
                "name": "issues",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "task",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Routine",
                        "kind": "LinkedField",
                        "name": "routine",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "taskExecution",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineSectionVersion",
                        "kind": "LinkedField",
                        "name": "sectionVersion",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v22/*: any*/),
                          (v10/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoutineSection",
                            "kind": "LinkedField",
                            "name": "section",
                            "plural": false,
                            "selections": [
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "assignedTeam",
                                "plural": false,
                                "selections": (v23/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resolved",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "images",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "minHeight",
                            "value": 699
                          },
                          {
                            "kind": "Literal",
                            "name": "minWidth",
                            "value": 699
                          }
                        ],
                        "concreteType": "ImageSize",
                        "kind": "LinkedField",
                        "name": "size",
                        "plural": false,
                        "selections": (v24/*: any*/),
                        "storageKey": "size(minHeight:699,minWidth:699)"
                      }
                    ],
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IssueAssignedUser",
                    "kind": "LinkedField",
                    "name": "assignedUsers",
                    "plural": true,
                    "selections": [
                      (v25/*: any*/),
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "assignedTeams",
                    "plural": true,
                    "selections": (v23/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "WidgetIssueOverview",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoCategory",
                "kind": "LinkedField",
                "name": "category",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": (v20/*: any*/),
                "storageKey": null
              },
              (v10/*: any*/),
              {
                "alias": null,
                "args": (v26/*: any*/),
                "concreteType": "TodoConnection",
                "kind": "LinkedField",
                "name": "allTodos",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TodoEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Todo",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v22/*: any*/),
                          (v14/*: any*/),
                          (v10/*: any*/),
                          (v27/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TodoCategoryTag",
                            "kind": "LinkedField",
                            "name": "tags",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              (v17/*: any*/),
                              (v10/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "assigneeText",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TodoAssignedUser",
                            "kind": "LinkedField",
                            "name": "assignedUsers",
                            "plural": true,
                            "selections": [
                              (v25/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "assignedAt",
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v19/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v26/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "WidgetTodoOverview__allTodos",
                "kind": "LinkedHandle",
                "name": "allTodos"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v31/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/)
                ],
                "type": "Widget",
                "abstractKey": "__isWidget"
              }
            ],
            "type": "WidgetTodoOverview",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v18/*: any*/),
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v17/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v57/*: any*/),
                      {
                        "alias": "column",
                        "args": null,
                        "concreteType": "TeamSchedule",
                        "kind": "LinkedField",
                        "name": "dailyTeamSchedule",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v37/*: any*/),
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "events",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v39/*: any*/),
                              (v38/*: any*/),
                              (v9/*: any*/),
                              (v47/*: any*/),
                              (v53/*: any*/),
                              (v55/*: any*/)
                            ],
                            "storageKey": "events(includeInlineRoutines:true)"
                          },
                          (v9/*: any*/),
                          (v35/*: any*/),
                          (v36/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetTeamScheduleContentDaily",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamSchedule",
                        "kind": "LinkedField",
                        "name": "weeklyTeamSchedule",
                        "plural": false,
                        "selections": (v56/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "column",
                        "args": null,
                        "concreteType": "TeamSchedule",
                        "kind": "LinkedField",
                        "name": "weeklyTeamSchedule",
                        "plural": false,
                        "selections": (v56/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetTeamScheduleContentWeekly",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamSchedule",
                        "kind": "LinkedField",
                        "name": "monthlyTeamSchedule",
                        "plural": false,
                        "selections": (v56/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": "column",
                        "args": null,
                        "concreteType": "TeamSchedule",
                        "kind": "LinkedField",
                        "name": "monthlyTeamSchedule",
                        "plural": false,
                        "selections": (v56/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetTeamScheduleContentMonthly",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v57/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamSchedule",
                        "kind": "LinkedField",
                        "name": "weeklyTeamSchedule",
                        "plural": false,
                        "selections": (v58/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamSchedule",
                        "kind": "LinkedField",
                        "name": "monthlyTeamSchedule",
                        "plural": false,
                        "selections": (v58/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetTeamScheduleContentSummary",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v59/*: any*/),
                  (v29/*: any*/),
                  (v31/*: any*/),
                  (v33/*: any*/),
                  (v34/*: any*/)
                ],
                "type": "Widget",
                "abstractKey": "__isWidget"
              }
            ],
            "type": "WidgetTeamSchedule",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v10/*: any*/),
              (v32/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetWeatherOccasion",
                "kind": "LinkedField",
                "name": "currentOccasion",
                "plural": false,
                "selections": [
                  (v60/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "temp",
                    "storageKey": null
                  },
                  (v40/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "WidgetWeatherOccasion",
                "kind": "LinkedField",
                "name": "occasions",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "date",
                    "storageKey": null
                  },
                  (v60/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lowTemp",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "highTemp",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v31/*: any*/),
                  (v34/*: any*/)
                ],
                "type": "Widget",
                "abstractKey": "__isWidget"
              }
            ],
            "type": "WidgetWeather",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Note",
                "kind": "LinkedField",
                "name": "note",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "editingMode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOrgNote",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "WidgetNotePage",
                    "kind": "LinkedField",
                    "name": "pages",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "alias": "largeImage",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "minHeight",
                                "value": 1080
                              },
                              {
                                "kind": "Literal",
                                "name": "minWidth",
                                "value": 1080
                              }
                            ],
                            "concreteType": "ImageSize",
                            "kind": "LinkedField",
                            "name": "size",
                            "plural": false,
                            "selections": [
                              (v11/*: any*/),
                              (v12/*: any*/),
                              (v13/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": "size(minHeight:1080,minWidth:1080)"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "includedInSlideshow",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "backgroundColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currentValue",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "version",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fontSize",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fontStyle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageScale",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageTranslateX",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageTranslateY",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v28/*: any*/),
                  (v31/*: any*/),
                  (v34/*: any*/)
                ],
                "type": "Widget",
                "abstractKey": "__isWidget"
              }
            ],
            "type": "WidgetNote",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "grouping",
                "storageKey": null
              },
              (v30/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "RoutineSectionVersion",
                "kind": "LinkedField",
                "name": "activeSectionVersions",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineSection",
                    "kind": "LinkedField",
                    "name": "section",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "assignedTeam",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v15/*: any*/),
                          (v17/*: any*/),
                          (v16/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "task",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unit",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Routine",
                        "kind": "LinkedField",
                        "name": "routine",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v61/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Schedule",
                            "kind": "LinkedField",
                            "name": "schedule",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RecurrenceRule",
                                "kind": "LinkedField",
                                "name": "rules",
                                "plural": true,
                                "selections": [
                                  (v36/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v62/*: any*/),
                        "concreteType": "TaskNumberOccasionConnection",
                        "kind": "LinkedField",
                        "name": "occasions",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TaskNumberOccasionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TaskNumberOccasion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RoutineOccasion",
                                    "kind": "LinkedField",
                                    "name": "occasion",
                                    "plural": false,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v38/*: any*/),
                                      (v54/*: any*/),
                                      (v43/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaskExecutionNumber",
                                    "kind": "LinkedField",
                                    "name": "taskExecutions",
                                    "plural": true,
                                    "selections": [
                                      (v63/*: any*/),
                                      (v51/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "TaskNumberGoals",
                                        "kind": "LinkedField",
                                        "name": "goals",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "lessThan",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "greaterThan",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v9/*: any*/),
                                      (v64/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "occasions(first:8)"
                      }
                    ],
                    "type": "TaskNumber",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Routine",
                        "kind": "LinkedField",
                        "name": "routine",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          (v61/*: any*/),
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": (v62/*: any*/),
                        "concreteType": "TaskCheckOccasionConnection",
                        "kind": "LinkedField",
                        "name": "occasions",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TaskCheckOccasionEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TaskCheckOccasion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "RoutineOccasion",
                                    "kind": "LinkedField",
                                    "name": "occasion",
                                    "plural": false,
                                    "selections": [
                                      (v38/*: any*/),
                                      (v54/*: any*/),
                                      (v9/*: any*/),
                                      (v43/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "TaskExecutionCheck",
                                    "kind": "LinkedField",
                                    "name": "taskExecutions",
                                    "plural": true,
                                    "selections": [
                                      (v51/*: any*/),
                                      (v52/*: any*/),
                                      (v9/*: any*/),
                                      (v64/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "occasions(first:8)"
                      }
                    ],
                    "type": "TaskCheck",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v65/*: any*/)
            ],
            "type": "WidgetTaskSingle",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "taskSections",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineSection",
                    "kind": "LinkedField",
                    "name": "section",
                    "plural": false,
                    "selections": (v48/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "task",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v9/*: any*/),
                      (v10/*: any*/),
                      (v49/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "inProgressTaskExecution",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isTaskExecution"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RoutineOccasion",
                        "kind": "LinkedField",
                        "name": "routineOccasion",
                        "plural": false,
                        "selections": [
                          (v54/*: any*/),
                          (v9/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v52/*: any*/)
                        ],
                        "type": "TaskExecutionCheck",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v63/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "formattedNumberValue",
                            "storageKey": null
                          }
                        ],
                        "type": "TaskExecutionNumber",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textValue",
                            "storageKey": null
                          }
                        ],
                        "type": "TaskExecutionText",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v65/*: any*/)
            ],
            "type": "WidgetTaskCollection",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v10/*: any*/),
              (v65/*: any*/)
            ],
            "type": "WidgetRoutineOverview",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Routine",
                "kind": "LinkedField",
                "name": "routines",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoutineOccasion",
                    "kind": "LinkedField",
                    "name": "lastCompletedOccasion",
                    "plural": false,
                    "selections": [
                      (v54/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "percentage",
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v65/*: any*/)
            ],
            "type": "WidgetRoutinePositivePercentage",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationIpool",
                "kind": "LinkedField",
                "name": "integration",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IntegrationIpoolEmployee",
                    "kind": "LinkedField",
                    "name": "employeesWithShifts",
                    "plural": true,
                    "selections": [
                      (v9/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IntegrationIpoolShift",
                        "kind": "LinkedField",
                        "name": "shifts",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          (v54/*: any*/),
                          (v38/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "IntegrationIpoolShiftPart",
                            "kind": "LinkedField",
                            "name": "parts",
                            "plural": true,
                            "selections": [
                              (v9/*: any*/),
                              (v38/*: any*/),
                              (v54/*: any*/),
                              (v61/*: any*/),
                              (v40/*: any*/),
                              (v17/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v59/*: any*/),
                  (v34/*: any*/)
                ],
                "type": "Widget",
                "abstractKey": "__isWidget"
              }
            ],
            "type": "WidgetIntegrationIpool",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v7/*: any*/)
            ],
            "type": "WidgetIntegrationPushAppy",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "IntegrationTurnpike",
                "kind": "LinkedField",
                "name": "integration",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "IntegrationTurnpikeSummary",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "acceptedTimeAverageInMs",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accepted",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unanswered",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rejected",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "total",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "WidgetIntegrationTurnpike",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamScheduleOneOffEvent",
                "kind": "LinkedField",
                "name": "events",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startAtFormatted",
                    "storageKey": null
                  },
                  (v38/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endAtFormatted",
                    "storageKey": null
                  },
                  (v40/*: any*/),
                  (v10/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "WidgetCalendar",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "FilePage",
                "kind": "LinkedField",
                "name": "pages",
                "plural": true,
                "selections": [
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Image",
                    "kind": "LinkedField",
                    "name": "image",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ImageSize",
                        "kind": "LinkedField",
                        "name": "size",
                        "plural": false,
                        "selections": (v24/*: any*/),
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "File",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "71dd445a5b280d007365b92982947070",
    "id": null,
    "metadata": {},
    "name": "FocusSingleWidgetQuery",
    "operationKind": "query",
    "text": "query FocusSingleWidgetQuery(\n  $nodeId: ID!\n  $first: Int\n  $after: String\n) {\n  node(id: $nodeId) {\n    __typename\n    ... on WidgetFile {\n      ...WidgetFileStatic_widgetFile\n      __typename\n    }\n    ... on WidgetIssueSummary {\n      ...WidgetIssueSummary_widgetIssueSummary\n      __typename\n    }\n    ... on WidgetEmployeeSchedule {\n      ...WidgetEmployeeSchedule_widgetEmployeeSchedule\n      __typename\n    }\n    ... on WidgetIssueOverview {\n      ...IssueFocusScreen_widgetIssueOverview\n      __typename\n    }\n    ... on WidgetTodoOverview {\n      ...TodoFocusScreen_widgetTodoOverview\n      __typename\n      ...WidgetTodoOverview_widget\n      ...useWidgetToPosSingleSize_widget\n    }\n    ... on WidgetTeamSchedule {\n      ...WidgetTeamSchedule_widget\n      ...TeamScheduleFocusScreen_widgetTeamSchedule\n      ...useWidgetToPosSingleSize_widget\n      __typename\n    }\n    ... on WidgetWeather {\n      ...WidgetWeather_widget\n      ...useWidgetToPosSingleSize_widget\n      __typename\n    }\n    ... on WidgetNote {\n      ...WidgetNote_widgetNote\n      ...useWidgetToPosSingleSize_widget\n      noteSize\n      __typename\n    }\n    ... on WidgetTaskSingle {\n      ...WidgetTaskSingle_widgetTaskSingle\n      ...useWidgetToPosSingleSize_widget\n      __typename\n    }\n    ... on WidgetTaskCollection {\n      ...WidgetTaskCollection_widgetTaskCollection\n      ...useWidgetToPosSingleSize_widget\n      __typename\n    }\n    ... on WidgetRoutineOverview {\n      ...WidgetRoutineOverview_widgetRoutineOverview\n      ...useWidgetToPosSingleSize_widget\n      __typename\n    }\n    ... on WidgetRoutinePositivePercentage {\n      ...WidgetRoutinePositivePercentage_widgetRoutinePositivePercentage\n      ...useWidgetToPosSingleSize_widget\n      __typename\n    }\n    ... on WidgetIntegrationIpool {\n      ...WidgetIpoolIntegration_widgetIntegrationIpool\n      ...useWidgetToPosSingleSize_widget\n      __typename\n    }\n    ... on WidgetIntegrationPushAppy {\n      webDashboardLink\n      __typename\n    }\n    ... on WidgetIntegrationTurnpike {\n      ...WidgetIntegrationTurnpike_widgetIntegrationTurnpike\n      turnpikeSize\n      __typename\n    }\n    ... on WidgetCalendar {\n      ...WidgetCalendar_widgetCalendar\n      __typename\n    }\n    ... on File {\n      ...FileFocusScreen_file\n      __typename\n    }\n    id\n  }\n}\n\nfragment CalendarEventItemListItem_eventItem on TeamScheduleOneOffEvent {\n  title\n  description\n}\n\nfragment EmployeeScheduleShiftBar on EmployeeShift {\n  status\n  formattedStartAtTime\n  formattedEndAtTime\n  durationSeconds\n  startAtSecondsFromMidnight\n  scheduleType {\n    title\n    color\n    id\n  }\n}\n\nfragment EmployeeScheduleShiftsEmployeeNamePanel_employee on Employee {\n  firstName\n  lastName\n}\n\nfragment EmployeeScheduleShiftsEmployee_employee on Employee {\n  id\n  ...EmployeeScheduleShiftsEmployeeNamePanel_employee\n  shifts {\n    id\n    ...EmployeeScheduleShiftBar\n  }\n}\n\nfragment FileFocusScreen_file on File {\n  id\n  pages {\n    id\n    image {\n      size {\n        url\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment IssueFocusDetailComponent_issue on Issue {\n  id\n  resolved\n  createdAt\n  title\n  assignedTeams {\n    id\n    name\n  }\n  taskExecution {\n    __typename\n    sectionVersion {\n      title\n      id\n    }\n    id\n  }\n  task {\n    __typename\n    title\n    routine {\n      title\n      ownerTeam {\n        name\n        id\n      }\n      id\n    }\n    id\n  }\n  images {\n    size(minWidth: 699, minHeight: 699) {\n      url\n      id\n    }\n    id\n  }\n}\n\nfragment IssueFocusScreen_widgetIssueOverview on WidgetIssueOverview {\n  id\n  issues {\n    id\n    ...WidgetIssueOverviewList_issue\n    ...IssueFocusDetailComponent_issue\n    ...IssueImagePreloader_issues\n  }\n}\n\nfragment IssueImagePreloader_issues on Issue {\n  images {\n    id\n    size(minWidth: 699, minHeight: 699) {\n      url\n      id\n    }\n  }\n}\n\nfragment NoteNative_note on Note {\n  id\n  editingMode\n  isOrgNote\n  title\n  pages {\n    id\n    image {\n      id\n    }\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment NoteWeb_note on Note {\n  id\n  title\n  isOrgNote\n  noteSize\n  editingMode\n  pages {\n    id\n    image {\n      id\n    }\n    includedInSlideshow\n    backgroundColor\n    ...WidgetNotePage_widgetNotePage\n  }\n}\n\nfragment RoutineOccasionStatusCircleInline_RoutineOccasion on RoutineOccasion {\n  id\n  status(calculateNoTasks: true)\n  deadlineAt\n  startAt\n  routine {\n    id\n    title\n  }\n}\n\nfragment RoutineOccasionStatusCircle_RoutineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true)\n  expireAt\n  deadlineAt\n  startAt\n}\n\nfragment SingleTaskInProgressCheck_taskExecutionCheck on TaskExecutionCheck {\n  ...taskExecutionListCheckTaskExecutions\n  checkValue\n  updatedAt\n}\n\nfragment TeamScheduleFocusScreenColumn_teamSchedule on TeamSchedule {\n  ...WidgetTeamScheduleContentList_teamSchedule\n  ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n  ...WidgetTeamScheduleContentStatus_teamSchedule\n}\n\nfragment TeamScheduleFocusScreenSummary_contentSummary on WidgetTeamScheduleContentSummary {\n  dailyTeamSchedule {\n    ...TeamScheduleFocusScreenColumn_teamSchedule\n    id\n  }\n  weeklyTeamSchedule {\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n    }\n    ...TeamScheduleFocusScreenColumn_teamSchedule\n    id\n  }\n  monthlyTeamSchedule {\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n    }\n    ...TeamScheduleFocusScreenColumn_teamSchedule\n    id\n  }\n}\n\nfragment TeamScheduleFocusScreen_widgetTeamSchedule on WidgetTeamSchedule {\n  id\n  teams {\n    id\n    color\n  }\n  overviewSize\n  content {\n    __typename\n    ... on WidgetTeamScheduleContentDaily {\n      column: dailyTeamSchedule {\n        events(includeInlineRoutines: true) {\n          __typename\n          ...useNowIndexes_teamScheduleEventOccasion\n          id\n        }\n        ...TeamScheduleFocusScreenColumn_teamSchedule\n        id\n      }\n    }\n    ... on WidgetTeamScheduleContentWeekly {\n      column: weeklyTeamSchedule {\n        ...TeamScheduleFocusScreenColumn_teamSchedule\n        id\n      }\n    }\n    ... on WidgetTeamScheduleContentMonthly {\n      column: monthlyTeamSchedule {\n        ...TeamScheduleFocusScreenColumn_teamSchedule\n        id\n      }\n    }\n    ... on WidgetTeamScheduleContentSummary {\n      dailyTeamSchedule {\n        events(includeInlineRoutines: true) {\n          __typename\n          ...useNowIndexes_teamScheduleEventOccasion\n          id\n        }\n        id\n      }\n      monthlyTeamSchedule {\n        events(includeInlineRoutines: true) {\n          __typename\n          id\n        }\n        id\n      }\n      weeklyTeamSchedule {\n        events(includeInlineRoutines: true) {\n          __typename\n          id\n        }\n        id\n      }\n      ...TeamScheduleFocusScreenSummary_contentSummary\n    }\n  }\n}\n\nfragment TodoCircleWidgetOverview_Todo on Todo {\n  expireAt\n  createdAt\n  status\n}\n\nfragment TodoFocusScreenListHeader_widgetTodoOverview on WidgetTodoOverview {\n  category {\n    title\n    id\n  }\n  teams {\n    name\n    id\n  }\n}\n\nfragment TodoFocusScreen_widgetTodoOverview on WidgetTodoOverview {\n  id\n  ...TodoFocusScreenListHeader_widgetTodoOverview\n  ...WidgetTodoOverviewListPaginated\n}\n\nfragment TodoOverviewListItemExpireInfo_Todo on Todo {\n  expireAt\n}\n\nfragment TodoOverviewListItemFooter_Todo on Todo {\n  tags {\n    id\n    color\n    title\n  }\n  assigneeText\n  assignedUsers {\n    user {\n      name\n      id\n    }\n    assignedAt\n    id\n  }\n}\n\nfragment TodoOverviewListItemWidget_Todo on Todo {\n  id\n  status\n  title\n  ...TodoOverviewListItemExpireInfo_Todo\n  ...TodoOverviewListItemFooter_Todo\n  ...TodoCircleWidgetOverview_Todo\n}\n\nfragment WidgetCalendarEvent_teamScheduleOneOffEvent on TeamScheduleOneOffEvent {\n  id\n  startAtFormatted\n  startAt\n  endAtFormatted\n  description\n  title\n}\n\nfragment WidgetCalendar_widgetCalendar on WidgetCalendar {\n  id\n  overviewSize\n  events {\n    id\n    ...WidgetCalendarEvent_teamScheduleOneOffEvent\n  }\n}\n\nfragment WidgetEmployeeScheduleIcon_widgetEmployeeSchedule on WidgetEmployeeSchedule {\n  provider\n}\n\nfragment WidgetEmployeeSchedule_widgetEmployeeSchedule on WidgetEmployeeSchedule {\n  id\n  overviewSize\n  ...WidgetEmployeeScheduleIcon_widgetEmployeeSchedule\n  employeesWithShifts {\n    id\n    shifts {\n      status\n      id\n    }\n    ...EmployeeScheduleShiftsEmployee_employee\n  }\n}\n\nfragment WidgetFilePageProcessing_file on File {\n  status\n}\n\nfragment WidgetFilePage_page on FilePage {\n  id\n  image {\n    id\n    ...Image_image\n  }\n}\n\nfragment WidgetFileStatic_widgetFile on WidgetFile {\n  id\n  title\n  slideshowDuration\n  files {\n    pages {\n      id\n      ...WidgetFilePage_page\n    }\n    file {\n      id\n      status\n      ...WidgetFilePageProcessing_file\n      name\n    }\n  }\n}\n\nfragment WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  acceptedTimeAverageInMs\n}\n\nfragment WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  accepted\n  unanswered\n  rejected\n  total\n}\n\nfragment WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  ...WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeLargeResponseRatioDetail_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary\n}\n\nfragment WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  acceptedTimeAverageInMs\n}\n\nfragment WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  accepted\n  total\n}\n\nfragment WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  accepted\n  unanswered\n  rejected\n}\n\nfragment WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  total\n}\n\nfragment WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary on IntegrationTurnpikeSummary {\n  ...WidgetIntegrationTurnpikeAcceptanceTimeBar_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseRatioBar_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseRatioAcceptedPercentageNumber_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseTotalNumber_integrationTurnpikeSummary\n  ...WidgetIntegrationTurnpikeResponseAcceptanceTimeNumber_integrationTurnpikeSummary\n}\n\nfragment WidgetIntegrationTurnpike_widgetIntegrationTurnpike on WidgetIntegrationTurnpike {\n  id\n  turnpikeSize\n  integration {\n    summary {\n      ...WidgetIntegrationTurnpikeSmall_integrationTurnpikeSummary\n      ...WidgetIntegrationTurnpikeLarge_integrationTurnpikeSummary\n    }\n    id\n  }\n}\n\nfragment WidgetIpoolIntegrationEmployeeNamePanel_ipoolEmployee on IntegrationIpoolEmployee {\n  id\n  name\n}\n\nfragment WidgetIpoolIntegrationEmployeeShiftsPart_integrationIpoolShiftPart on IntegrationIpoolShiftPart {\n  startAt\n  endAt\n  type\n  description\n  color\n}\n\nfragment WidgetIpoolIntegrationEmployeeShifts_integrationIpoolEmployee on IntegrationIpoolEmployee {\n  id\n  shifts {\n    id\n    ...WidgetIpoolIntegrationEmployeeShifts_integrationIpoolShift\n  }\n}\n\nfragment WidgetIpoolIntegrationEmployeeShifts_integrationIpoolShift on IntegrationIpoolShift {\n  id\n  startAt\n  endAt\n  parts {\n    id\n    ...WidgetIpoolIntegrationEmployeeShiftsPart_integrationIpoolShiftPart\n  }\n}\n\nfragment WidgetIpoolIntegration_widgetIntegrationIpool on WidgetIntegrationIpool {\n  id\n  overviewSize\n  integration {\n    employeesWithShifts {\n      id\n      ...WidgetIpoolIntegrationEmployeeNamePanel_ipoolEmployee\n      shifts {\n        id\n        endAt\n      }\n      ...WidgetIpoolIntegrationEmployeeShifts_integrationIpoolEmployee\n    }\n    id\n  }\n}\n\nfragment WidgetIssueOverviewIssueItemAssignees_issue on Issue {\n  assignedUsers {\n    user {\n      name\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetIssueOverviewIssueItemContent_issue on Issue {\n  id\n  resolved\n  ...WidgetIssueOverviewIssueItemImageThumbanil_issue\n  ...WidgetIssueOverviewIssueItemTitles_issue\n  ...WidgetIssueOverviewIssueItemAssignees_issue\n  ...WidgetIssueOverviewIssueItemSectionTitle_issue\n}\n\nfragment WidgetIssueOverviewIssueItemImageThumbanil_issue on Issue {\n  images {\n    id\n  }\n}\n\nfragment WidgetIssueOverviewIssueItemSectionTitle_issue on Issue {\n  taskExecution {\n    __typename\n    sectionVersion {\n      title\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetIssueOverviewIssueItemTitles_issue on Issue {\n  task {\n    __typename\n    title\n    id\n  }\n  title\n}\n\nfragment WidgetIssueOverviewIssueItem_issue on Issue {\n  id\n  resolved\n  ...WidgetIssueOverviewIssueItemContent_issue\n}\n\nfragment WidgetIssueOverviewList_issue on Issue {\n  id\n  createdAt\n  task {\n    __typename\n    id\n    title\n    routine {\n      id\n      title\n      ownerTeam {\n        name\n        id\n      }\n    }\n  }\n  taskExecution {\n    __typename\n    id\n    sectionVersion {\n      id\n      ordinal\n      title\n      section {\n        id\n        assignedTeam {\n          id\n          name\n        }\n      }\n    }\n  }\n  ...WidgetIssueOverviewIssueItem_issue\n}\n\nfragment WidgetIssueSummaryTeamItemUnresolvedCount_team on Team {\n  unresolvedIssueCount\n}\n\nfragment WidgetIssueSummaryTeamItem_team on Team {\n  id\n  name\n  icon\n  color\n  ...WidgetIssueSummaryTeamItemUnresolvedCount_team\n}\n\nfragment WidgetIssueSummary_widgetIssueSummary on WidgetIssueSummary {\n  id\n  title\n  teams {\n    id\n    unresolvedIssueCount\n    ...WidgetIssueSummaryTeamItem_team\n  }\n}\n\nfragment WidgetNotePageBackground_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  image {\n    id\n    largeImage: size(minHeight: 1080, minWidth: 1080) {\n      url\n      height\n      width\n      id\n    }\n  }\n  imageScale\n  imageTranslateX\n  imageTranslateY\n}\n\nfragment WidgetNotePage_widgetNotePage on WidgetNotePage {\n  id\n  currentValue\n  version\n  ...useNoteWidgetStyleText_widgetNotePage\n  ...WidgetNotePageBackground_widgetNotePage\n}\n\nfragment WidgetNote_widgetNote on WidgetNote {\n  id\n  note {\n    editingMode\n    isOrgNote\n    pages {\n      id\n    }\n    ...NoteWeb_note\n    ...NoteNative_note\n    id\n  }\n}\n\nfragment WidgetRoutineOverview_widgetRoutineOverview on WidgetRoutineOverview {\n  id\n  title\n}\n\nfragment WidgetRoutinePositivePercentageRoutineItem_routine on Routine {\n  id\n  title\n  ownerTeam {\n    name\n    id\n  }\n  lastCompletedOccasion {\n    endAt\n    percentage\n    id\n  }\n}\n\nfragment WidgetRoutinePositivePercentage_widgetRoutinePositivePercentage on WidgetRoutinePositivePercentage {\n  id\n  title\n  routines {\n    id\n    ...WidgetRoutinePositivePercentageRoutineItem_routine\n  }\n}\n\nfragment WidgetTaskCollection_widgetTaskCollection on WidgetTaskCollection {\n  id\n  title\n  taskSections {\n    __typename\n    id\n    section {\n      id\n      title\n    }\n    task {\n      __typename\n      id\n      title\n      routine {\n        id\n        title\n      }\n    }\n    inProgressTaskExecution {\n      __typename\n      ...WidgetTaskMultipleRenderTask_taskExecution\n      id\n    }\n  }\n}\n\nfragment WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck on TaskExecutionCheck {\n  checkValue\n}\n\nfragment WidgetTaskMultipleRenderTaskContent_taskExecution on TaskExecution {\n  __isTaskExecution: __typename\n  ... on TaskExecutionCheck {\n    __typename\n    ...WidgetTaskMultipleRenderTaskCheck_taskExecutionCheck\n  }\n  ... on TaskExecutionNumber {\n    __typename\n    ...WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber\n  }\n  ... on TaskExecutionText {\n    __typename\n    ...WidgetTaskMultipleRenderTaskText_taskExecutionText\n  }\n}\n\nfragment WidgetTaskMultipleRenderTaskNumber_taskExecutionNumber on TaskExecutionNumber {\n  numberValue\n  formattedNumberValue\n}\n\nfragment WidgetTaskMultipleRenderTaskText_taskExecutionText on TaskExecutionText {\n  textValue\n}\n\nfragment WidgetTaskMultipleRenderTask_taskExecution on TaskExecution {\n  __isTaskExecution: __typename\n  ...WidgetTaskMultipleRenderTaskContent_taskExecution\n  routineOccasion {\n    endAt\n    id\n  }\n}\n\nfragment WidgetTaskSingleCheckSmallInProgress_taskExecutions on TaskExecutionCheck {\n  checkValue\n  ...taskExecutionListCombineCheckTaskExecutions\n}\n\nfragment WidgetTaskSingleCheck_taskCheck on TaskCheck {\n  id\n  title\n  routine {\n    id\n    title\n  }\n  occasions(first: 8) {\n    edges {\n      node {\n        id\n        ...WidgetTaskSingleCheck_taskCheckOccasion\n        taskExecutions {\n          id\n          checkValue\n          sectionId\n          ...WidgetTaskSingleCheckSmallInProgress_taskExecutions\n          ...SingleTaskInProgressCheck_taskExecutionCheck\n        }\n        occasion {\n          id\n          startAt\n          endAt\n          sequenceNumber\n        }\n      }\n    }\n  }\n}\n\nfragment WidgetTaskSingleCheck_taskCheckOccasion on TaskCheckOccasion {\n  id\n  occasion {\n    startAt\n    endAt\n    id\n  }\n  taskExecutions {\n    sectionId\n    checkValue\n    id\n  }\n}\n\nfragment WidgetTaskSingleNumberOccasionPage_taskNumber on TaskNumber {\n  id\n  unit\n  title\n  routine {\n    id\n    title\n    type\n    schedule {\n      rules {\n        freq\n      }\n    }\n  }\n  occasions(first: 8) {\n    edges {\n      node {\n        id\n        occasion {\n          id\n          startAt\n          endAt\n          sequenceNumber\n        }\n        taskExecutions {\n          numberValue\n          sectionId\n          goals {\n            lessThan\n            greaterThan\n          }\n          ...useGroupNumberTaskExecution_taskExecutionNumber\n          updatedAt\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment WidgetTaskSingle_widgetTaskSingle on WidgetTaskSingle {\n  id\n  title\n  grouping\n  taskSingleSize\n  ...useWidgetTaskSingleSections_widgetTaskSingle\n  activeSectionVersions {\n    section {\n      id\n    }\n    id\n  }\n  task {\n    __typename\n    ... on TaskNumber {\n      id\n      ...WidgetTaskSingleNumberOccasionPage_taskNumber\n      routine {\n        id\n        type\n        title\n      }\n      __typename\n    }\n    ... on TaskCheck {\n      id\n      routine {\n        id\n        type\n        title\n      }\n      ...WidgetTaskSingleCheck_taskCheck\n      __typename\n    }\n    id\n  }\n}\n\nfragment WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily on WidgetTeamScheduleContentDaily {\n  dailyTeamSchedule {\n    ...WidgetTeamScheduleContentList_teamSchedule\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      ...useNowIndexes_teamScheduleEventOccasion\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetTeamScheduleContentList_teamSchedule on TeamSchedule {\n  id\n  label\n  freq\n  events(includeInlineRoutines: true) {\n    __typename\n    id\n    startAt\n    ... on RoutineOccasion {\n      routine {\n        id\n        description\n        descriptionImages {\n          id\n        }\n      }\n    }\n    ... on TeamScheduleInlineRoutineOccasion {\n      taskExecution {\n        routine {\n          id\n          description\n          descriptionImages {\n            id\n          }\n        }\n        id\n      }\n    }\n    ...useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion\n    ...WidgetTeamScheduleListItem_item\n  }\n}\n\nfragment WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly on WidgetTeamScheduleContentMonthly {\n  monthlyTeamSchedule {\n    ...WidgetTeamScheduleContentList_teamSchedule\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    ...WidgetTeamScheduleContentStatus_teamSchedule\n    id\n  }\n}\n\nfragment WidgetTeamScheduleContentSectionHeader_teamSchedule on TeamSchedule {\n  id\n  freq\n  label\n  ...WidgetTeamScheduleContentStatus_teamSchedule\n}\n\nfragment WidgetTeamScheduleContentStatus_teamSchedule on TeamSchedule {\n  events(includeInlineRoutines: true) {\n    __typename\n    id\n    ... on RoutineOccasion {\n      __typename\n      status(calculateNoTasks: true)\n      ...WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion\n    }\n    ... on TeamScheduleInlineRoutineOccasion {\n      __typename\n      taskExecution {\n        routineOccasion {\n          status(calculateNoTasks: true)\n          __typename\n          ...WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary on WidgetTeamScheduleContentSummary {\n  dailyTeamSchedule {\n    id\n    ...WidgetTeamScheduleContentList_teamSchedule\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n      ...useNowIndexes_teamScheduleEventOccasion\n    }\n  }\n  weeklyTeamSchedule {\n    id\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n    }\n  }\n  monthlyTeamSchedule {\n    id\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    events(includeInlineRoutines: true) {\n      __typename\n      id\n    }\n  }\n}\n\nfragment WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly on WidgetTeamScheduleContentWeekly {\n  weeklyTeamSchedule {\n    ...WidgetTeamScheduleContentList_teamSchedule\n    ...WidgetTeamScheduleContentSectionHeader_teamSchedule\n    id\n  }\n}\n\nfragment WidgetTeamScheduleInlineRoutineListItem_TeamScheduleInlineRoutineOccasion on TeamScheduleInlineRoutineOccasion {\n  id\n  taskExecution {\n    id\n    task {\n      id\n    }\n    sectionId\n    routineOccasion {\n      id\n      sequenceNumber\n      ...WidgetTeamScheduleRoutineListItemContent_RoutineOccasion\n      ...WidgetTeamScheduleRoutineIssueIndicator_routineOccasion\n      ...RoutineOccasionStatusCircleInline_RoutineOccasion\n    }\n    routine {\n      id\n      ...WidgetTeamScheduleRoutineListItemContent_Routine\n    }\n    checkValue\n  }\n}\n\nfragment WidgetTeamScheduleListItem_item on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  ... on TeamScheduleInlineRoutineOccasion {\n    id\n    startAt\n    taskExecution {\n      routineOccasion {\n        deadlineAt\n        sequenceNumber\n        id\n      }\n      routine {\n        id\n      }\n      id\n    }\n    __typename\n    ...WidgetTeamScheduleInlineRoutineListItem_TeamScheduleInlineRoutineOccasion\n  }\n  ... on RoutineOccasion {\n    id\n    __typename\n    startAt\n    deadlineAt\n    sequenceNumber\n    routine {\n      id\n    }\n    ...WidgetTeamScheduleRoutineOccasionListItem_item\n  }\n  ... on TeamScheduleOneOffEvent {\n    startAt\n    endAt\n    ...CalendarEventItemListItem_eventItem\n    __typename\n  }\n}\n\nfragment WidgetTeamScheduleRoutineIssueIndicator_routineOccasion on RoutineOccasion {\n  issueCount\n}\n\nfragment WidgetTeamScheduleRoutineListItemContent_Routine on Routine {\n  id\n  description\n  title\n  isOrg\n  descriptionImages {\n    size(minHeight: 120, minWidth: 120) {\n      url\n      id\n    }\n    id\n  }\n}\n\nfragment WidgetTeamScheduleRoutineListItemContent_RoutineOccasion on RoutineOccasion {\n  startAt\n  deadlineAt\n}\n\nfragment WidgetTeamScheduleRoutineOccasionListItem_item on RoutineOccasion {\n  ...RoutineOccasionStatusCircle_RoutineOccasion\n  ...WidgetTeamScheduleRoutineIssueIndicator_routineOccasion\n  ...WidgetTeamScheduleRoutineListItemContent_RoutineOccasion\n  totalTaskExecutionCount\n  sequenceNumber\n  routine {\n    id\n    ...WidgetTeamScheduleRoutineListItemContent_Routine\n  }\n}\n\nfragment WidgetTeamScheduleSectionHeaderStatusDot_routineOccasion on RoutineOccasion {\n  status(calculateNoTasks: true)\n  totalTaskExecutionCount\n}\n\nfragment WidgetTeamSchedule_widget on WidgetTeamSchedule {\n  id\n  overviewSize\n  title\n  teams {\n    id\n    color\n    name\n    icon\n  }\n  content {\n    __typename\n    ... on WidgetTeamScheduleContentDaily {\n      ...WidgetTeamScheduleContentDaily_WidgetTeamScheduleContentDaily\n    }\n    ... on WidgetTeamScheduleContentWeekly {\n      ...WidgetTeamScheduleContentWeekly_WidgetTeamScheduleContentWeekly\n    }\n    ... on WidgetTeamScheduleContentMonthly {\n      ...WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly\n    }\n    ... on WidgetTeamScheduleContentSummary {\n      ...WidgetTeamScheduleContentSummary_WidgetTeamScheduleContentSummary\n    }\n  }\n}\n\nfragment WidgetTodoOverviewListPaginated on WidgetTodoOverview {\n  id\n  title\n  category {\n    id\n    title\n  }\n  teams {\n    id\n  }\n  allTodos(first: $first, after: $after) {\n    edges {\n      node {\n        id\n        ordinal\n        status\n        ...TodoOverviewListItemWidget_Todo\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment WidgetTodoOverview_widget on WidgetTodoOverview {\n  id\n  title\n  category {\n    id\n    title\n  }\n  teams {\n    id\n  }\n}\n\nfragment WidgetWeatherBackground_WidgetWeather on WidgetWeather {\n  currentOccasion {\n    condition\n  }\n}\n\nfragment WidgetWeatherConditionIcon_WeatherOccasion on WidgetWeatherOccasion {\n  condition\n}\n\nfragment WidgetWeatherCurrentPane_weatherOccasion on WidgetWeatherOccasion {\n  temp\n  description\n}\n\nfragment WidgetWeatherDatePaneListItem_WeatherOccasion on WidgetWeatherOccasion {\n  date\n  condition\n  lowTemp\n  highTemp\n  ...WidgetWeatherConditionIcon_WeatherOccasion\n}\n\nfragment WidgetWeather_widget on WidgetWeather {\n  id\n  title\n  size\n  ...WidgetWeatherBackground_WidgetWeather\n  currentOccasion {\n    ...WidgetWeatherCurrentPane_weatherOccasion\n  }\n  occasions {\n    date\n    ...WidgetWeatherDatePaneListItem_WeatherOccasion\n  }\n}\n\nfragment taskExecutionListCheckTaskExecutions on TaskExecutionCheck {\n  id\n  sectionId\n  checkValue\n}\n\nfragment taskExecutionListCombineCheckTaskExecutions on TaskExecutionCheck {\n  checkValue\n}\n\nfragment useGroupNumberTaskExecution_taskExecutionNumber on TaskExecutionNumber {\n  id\n  sectionId\n  numberValue\n  updatedAt\n  goals {\n    lessThan\n    greaterThan\n  }\n}\n\nfragment useNoteWidgetStyleText_widgetNotePage on WidgetNotePage {\n  backgroundColor\n  fontSize\n  fontStyle\n  image {\n    id\n  }\n}\n\nfragment useNowIndexes_teamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  startAt\n}\n\nfragment useWidgetTaskSingleSections_widgetTaskSingle on WidgetTaskSingle {\n  activeSectionVersions {\n    id\n    title\n    ordinal\n    section {\n      id\n      assignedTeam {\n        id\n        name\n        color\n        icon\n      }\n    }\n  }\n}\n\nfragment useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion on TeamScheduleEventOccasion {\n  __isTeamScheduleEventOccasion: __typename\n  id\n  ... on TeamScheduleInlineRoutineOccasion {\n    taskExecution {\n      routine {\n        id\n      }\n      id\n    }\n  }\n  ... on RoutineOccasion {\n    routine {\n      id\n    }\n  }\n}\n\nfragment useWidgetToPosSingleSize_widget on Widget {\n  __isWidget: __typename\n  __typename\n  ... on WidgetOverview {\n    __isWidgetOverview: __typename\n    overviewSize\n  }\n  ... on WidgetNote {\n    noteSize\n  }\n  ... on WidgetTaskSingle {\n    taskSingleSize\n  }\n  ... on WidgetWeather {\n    size\n  }\n  ... on WidgetIntegrationTurnpike {\n    turnpikeSize\n  }\n}\n"
  }
};
})();

(node as any).hash = "8e2a98b2ba999135294e61f20b91e718";

export default node;
